import React, {useState, useEffect} from "react";
import { useLocation } from "react-router-dom";
import { Box, Container, Grid } from "@mui/material";
import Footer from "../footer/Footer";

const BodyMain = ({children}) => {
    let location = useLocation();
    const [hideHeader, setHideHeader] = useState(false);


    useEffect(() => {
        setHideHeader(location.pathname==='/termsofuse' 
                || location.pathname==='/privacypolicy'
                || location.pathname==='/enduserdata'
        );
    }, [location.pathname]);

    
    return(
        <>
            <Box sx={{
                width:'100%',
                height:'100vh',
                display:'flex',
                flexDirection:'column',
            }}>
                <Grid container direction="row" size={12}
                    sx={{
                        flex:1,
                        margin:0, 
                        padding:0,
                        top:0,
                        left:0,
                        overflowX:'none',
                        overflowY:'none',
                        background: (theme) => 
                            `linear-gradient(45deg, 
                                ${theme.palette.grey[300]} 25%, 
                                transparent 25%, 
                                transparent 50%, 
                                ${theme.palette.grey[300]} 50%, 
                                ${theme.palette.grey[300]} 75%, 
                                transparent 75%, transparent)`,
                        backgroundColor: (theme) => 
                                theme.palette.grey[100],
                        backgroundSize: '8px 8px'
                    }}
                >
                    <Grid size={{
                        sxs:0,
                        xs:0,
                        sm:1,
                        md:1,
                        lg:1,
                        xl:1,
                    }}>&nbsp;</Grid>
                    <Grid size={10} 
                        sx={{
                            display:'flex',
                            flexDirection:'column',
                            flex:1,
                        }}
                    >
                            <Box sx={{
                                flex:1,
                                display:'flex',
                                flexDirection:'column',
                                padding:'20px',
                                paddingTop: hideHeader ? '0px' : '110px',
                                borderLeft: '2px solid #e1e1e1',
                                borderRight: '1px solid #e1e1e1',
                                boxShadow: '3px 0px rgb(213, 213, 213)',
                                backgroundColor:'white'
                            }}>
                                {children}
                            </Box>
                    </Grid>
                    <Grid size={{
                        sxs:0,
                        xs:0,
                        sm:1,
                        md:1,
                        lg:1,
                        xl:1,
                    }}>&nbsp;</Grid>
                </Grid>
                <Grid container direction="row" size={12}
                    sx={{
                        width:'100%', 
                        maxHeight:'50px',
                        fontSize:12,
                        paddingTop:'10px',
                        paddingBottom:'10px',
                        backgroundColor:'rgb(239, 239, 239)',
                        borderTop:'1px solid rgb(184, 184, 184)'
                    }}
                >
                    <Grid size={1}>&nbsp;</Grid>
                    <Grid size={10}><Footer /></Grid>
                    <Grid size={1}>&nbsp;</Grid>
                </Grid>
            </Box>
        </>
    );
};

export default BodyMain;